module.exports = __webpack_public_path__ + "img/text-das.20614b6e.png";